export enum ECoverageAreaType {
  DealerMap = "DealerMap",
  DealerStore = "DealerStore",
  DriverStore = "DriverStore",
}
